import React, { useState, useEffect } from 'react';
import styles from './customEvaluation.module.scss';
import { Card, Col, Row, Image } from 'react-bootstrap';
import { getAllCustomEvaluationGroups } from '../../../services/util/customEvaluation';
import CSSLoader from '../../shared/cssLoader';
import { Helmet } from "react-helmet";
import ReactGA from 'react-ga4';
import CustomNavbar from '../customNavbar';
import { CustomButton } from '../../shared/customButton';
import { Tooltip as ReactTooltip } from 'react-tooltip'
import { CustomAlertBox } from '../../shared/customAlertBox';
import { CustomAvatarList } from '../../shared/customAvatarList';
import { CustomPreIcon } from '../../shared/customPreIcon';

const CustomEvaluation = (props) => {
    let concatValue;
    const [isLoading, setLoading] = useState(false);
    let [customEvaluationReviewValues, setCustomEvaluationValues] = useState([]);
    const breadcrumb = [
        {
            pathaddress: '/app/company/custom-evaluations',
            pathname: 'Custom Evaluations',
            isActive: false,
            key: 1 + 'custom-evaluation'
        }
    ]

    const breacrumbText = 'In here you can see candidates who are waiting for custom evaluations (such as practical assignments, in-person exams etc.). Do the evaluations and submit your feedback.'

    const getAllCustomEvaluationReviews = async () => {
        setLoading(true)
        const values = await getAllCustomEvaluationGroups();
        if (values.success === true) {
            setCustomEvaluationValues(values.data)
            setLoading(false)
        } else {
            setLoading(false)
        }
    }

    function ViewCustomEvaluationDetails(step_id) {
        props.history({
            pathname: `/company/custom-evaluations/group`,
            search: `?step_id=${step_id}`
        });
    }

    function addMaxViewLength(values, size) {
        concatValue = values.length > size ? values.slice(0, size - 1) + "…" : values;
    }

    function truncateValue(value, maxLength) {
        return value.length > maxLength ? value.slice(0, maxLength - 1) + "…" : value;
    }

    // Company Settings Integration API call
    let [isURLLoading, setURLLoading] = useState(false);


    useEffect(() => {
        getAllCustomEvaluationReviews();
    }, []);

    useEffect(() => {
        let pageHit = '/app/company/custom_evaluations';
        props.toggleInterviewView(false);
        ReactGA.initialize(`${process.env.REACT_APP_CUSTOMER_FLOW_GOOGLE_ANALYTICS_ID}`);
        ReactGA.send({ hitType: "pageview", page: pageHit});
    }, [])


    return (
        <div>
            <Helmet>
                <title>Custom Evaluation | HireTrace</title>
            </Helmet>
            {isLoading === true ?
                (<div className={styles.loadingDiv}>
                    <Col sm={{ span: 4, offset: 4 }}>
                        <CSSLoader />
                    </Col>
                </div>)
                :
                (<div>
                    <div className={styles.backgroundFixedComponents}>
                        <CustomNavbar history={props.mainHistory} breadcrumbArray={breadcrumb} breacrumbText= {breacrumbText}/>
                    </div>
                    <div className={styles.BodyContainer}>
                        <Col>
                            <Row>
                                {
                                    (customEvaluationReviewValues).map((values, index) => (
                                        <Col sm={6} lg={4} className="mb-4" key={index}>

                                            <Card className={styles.cardOuterBox}>
                                                <Card.Body >
                                                    <div className={styles.cardTitleBox}>
                                                        <CustomPreIcon
                                                            type="successIcon"
                                                            icon={
                                                                <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <g id="package-plus">
                                                                        <path id="Icon" d="M20.5 7.27777L12 12M12 12L3.49997 7.27777M12 12L12 21.5M14 20.8889L12.777 21.5683C12.4934 21.7259 12.3516 21.8047 12.2015 21.8356C12.0685 21.8629 11.9315 21.8629 11.7986 21.8356C11.6484 21.8047 11.5066 21.7259 11.223 21.5683L3.82297 17.4572C3.52346 17.2908 3.37368 17.2076 3.26463 17.0893C3.16816 16.9846 3.09515 16.8605 3.05048 16.7253C3 16.5725 3 16.4012 3 16.0586V7.94147C3 7.59883 3 7.42751 3.05048 7.27471C3.09515 7.13953 3.16816 7.01545 3.26463 6.91076C3.37368 6.79242 3.52345 6.70922 3.82297 6.54282L11.223 2.43171C11.5066 2.27415 11.6484 2.19537 11.7986 2.16448C11.9315 2.13715 12.0685 2.13715 12.2015 2.16448C12.3516 2.19537 12.4934 2.27415 12.777 2.43171L20.177 6.54282C20.4766 6.70922 20.6263 6.79242 20.7354 6.91076C20.8318 7.01545 20.9049 7.13953 20.9495 7.27471C21 7.4275 21 7.59883 21 7.94147L21 12.5M7.5 4.50002L16.5 9.50002M19 21V15M16 18H22" stroke="#039855" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                                                    </g>
                                                                </svg>
                                                            }
                                                        />
                                                        <div className={styles.cardTitleText}>
                                                            <p className={styles.cardTitlePrimaryText} data-tooltip-id={values.pipeline_name + index} onChange={addMaxViewLength(values.pipeline_name, 80)}>{concatValue}</p>
                                                            {(values.pipeline_name).length > 80 &&
                                                                <ReactTooltip id={values.pipeline_name + index} place="bottom" type="dark" effect="solid">
                                                                    <span>{values.pipeline_name}</span>
                                                                </ReactTooltip>
                                                            }
                                                            <p className={styles.cardTitleSecondaryText}>
                                                                {truncateValue(values.hiring_position, 22)}
                                                                {" | "}
                                                                {truncateValue(values.step_name, 22)}
                                                            </p>

                                                            {(values.hiring_position).length > 22 &&
                                                                <ReactTooltip id={values.hiring_position + index} place="bottom" type="dark" effect="solid">
                                                                    <span>{values.hiring_position}</span>
                                                                </ReactTooltip>
                                                            }
                                                            {(values.step_name).length > 22 &&
                                                                <ReactTooltip id={values.step_name + index} place="bottom" type="dark" effect="solid">
                                                                    <span>{values.step_name}</span>
                                                                </ReactTooltip>
                                                            }
                                                        </div>
                                                    </div>
                                                    <hr className={styles.horizontalDivider} />
                                                    <div className={styles.cardBodyText}>
                                                        <p >
                                                            {`${values.job_type === 10 ? "Full-Time" : values.job_type === 20 ? "Part-Time" : values.job_type === 30 ? "Contract/ Temp" : values.job_type === 40 ? "Casual/ Vacation" : values.job_type === 50 ? "Internship" : ''}`}
                                                            {`${values.work_type === 10 ? " | Remote" : values.work_type === 20 ? " | On-site" : values.work_type === 30 ? " | Hybrid" : ''}`}
                                                            {`${values.location ? ` | ${values.location}` : ''}`}
                                                        </p>
                                                    </div>
                                                    <div className={styles.reviewDetails}>
                                                        <div>
                                                            <CustomAvatarList nameArray={values.top_candidate_name_list} totalUsers={values.candidate_count}></CustomAvatarList>
                                                        </div>
                                                        <div className={styles.cardBtn}>

                                                            <CustomButton
                                                                buttonType="button"
                                                                label="Start Review"
                                                                type="secondaryBtn"
                                                                backicon={
                                                                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                        <path d="M9 16.5C13.1421 16.5 16.5 13.1421 16.5 9C16.5 4.85786 13.1421 1.5 9 1.5C4.85786 1.5 1.5 4.85786 1.5 9C1.5 13.1421 4.85786 16.5 9 16.5Z" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                                        <path d="M9 12L12 9L9 6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                                        <path d="M6 9H12" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                                    </svg>
                                                                }
                                                                handleClick={() => ViewCustomEvaluationDetails(values.step_id)}
                                                            />
                                                        </div>
                                                    </div>
                                                </Card.Body>
                                            </Card>


                                        </Col>
                                    ))

                                }
                            </Row>
                        </Col>
                        <div className={styles.NoContainer}>
                            {
                                customEvaluationReviewValues.length === 0 &&
                                (<div>
                                    <Col>
                                        {/* <p className={styles.infoMessage}>Currently no Custom Evaluations assigned to you to review. Learn more
                                                    about  <a href='https://hiretrace.io/documentation/cv-reviews/overview' target="_blank">Custom Evaluations</a>. </p> */}
                                        <p className={styles.infoMessage}>Currently no Custom Evaluations assigned to you to review. </p>
                                    </Col>
                                    <Col xs={{ span: 6, offset: 3 }} sm={{ span: 4, offset: 4 }}>
                                        <Image src={`${process.env.REACT_APP_FRONTEND_BASE_URL}/images/cvReview.svg`} fluid />
                                    </Col>
                                </div>)
                            }
                        </div>
                    </div>

                </div>)
            }
        </div>
    )
}
export default CustomEvaluation;